import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { JOBS_URL, CRITERIA_URL } from '../../../constants/navRoutes';
import { JOBSBOARD_TITLE, JOBS_TITLE, CRITERIA_TITLE } from '../../../constants/titles';

import Button from '../../common/button';
import { ReactComponent as LogoBlack } from '../../../assets/logo-black.svg';
import { spacing, fontSize } from '../../../theme';

const JobsBoardSection = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: ${spacing.medium};
    font-size: ${fontSize.small};
`;

const Tagline = styled.h4`
  font-weight: 400;
`;

const Description = styled.p`
  font-weight: 600;
  max-width: 30em;
  text-align: center;
  font-size: ${fontSize.small};
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: ${spacing.small} 0;
`;

const LogoContainer = styled.div`
  padding: ${spacing.small};
`;

const JobsBoard = ({ setTitle }) => {

  setTitle(JOBSBOARD_TITLE);

  return (
    <JobsBoardSection>
      <LogoContainer>
        <LogoBlack />
        <Tagline>A future-work agency.</Tagline>
      </LogoContainer>
      <Description>
        Start work with an employer who has started their work towards genuine
        inclusion.
        <br />
        Find roles in organisations that want to nurture your talent.
      </Description>
      <ButtonContainer>
        <NavLink to={JOBS_URL} onClick={() => setTitle(JOBS_TITLE)}>
          <Button label="See employers" />
        </NavLink>
        <NavLink to={CRITERIA_URL} onClick={() => setTitle(CRITERIA_TITLE)}>
          <Button label="Our criteria" />
        </NavLink>
      </ButtonContainer>
    </JobsBoardSection>
  );
};

export default JobsBoard;
